import React, { ChangeEvent } from 'react'
import Switch from '@mui/material/Switch'
import makeStyles from '@mui/styles/makeStyles'
import createStyles from '@mui/styles/createStyles'

interface CustomSwitchProps {
  id: string
  name: string
  checked: boolean
  onChange: (checked: boolean) => void
}

export const useStyles = makeStyles(theme =>
  createStyles({
    root: {
      width: 40,
      height: 20,
      padding: 0,
      '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 2,
        transitionDuration: '300ms',
        '&.Mui-checked': {
          transform: 'translateX(20px)',
          color: '#fff',
          '& + .MuiSwitch-track': {
            backgroundColor: theme.colors.black,
            opacity: 1,
            border: 0,
          },
          '&.Mui-disabled + .MuiSwitch-track': {
            opacity: 0.5,
          },
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
          color: '#33cf4d',
          border: '6px solid #fff',
        },
        '&.Mui-disabled .MuiSwitch-thumb': {
          color: theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600],
        },
        '&.Mui-disabled + .MuiSwitch-track': {
          opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
        },
      },
      '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        boxShadow: 'none',
        width: 16,
        height: 16,
      },
      '& .MuiSwitch-track': {
        borderRadius: 22 / 2,
        backgroundColor: theme.colors.grey,
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
          duration: 500,
        }),
      },
    },
  })
)

const CustomSwitch = (props: CustomSwitchProps) => {
  const { onChange, checked, id, name } = props
  const classes = useStyles()

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.checked)
  }

  return (
    <Switch
      classes={{
        root: classes.root,
      }}
      id={id}
      name={name}
      disableRipple
      checked={checked}
      onChange={handleChange}
    />
  )
}

export default CustomSwitch
